import styled, { css } from "styled-components";
import { getTypographyStyle } from "ui/config/theme/GlobalStyles/components/util/getTypographyStyle";
import TextField from "../../TextField/TextField";

export const AutocompleteInputRoot = styled(TextField)(
    ({ theme }) => css`
        &.TextField.TextField.FormControl {
            height: unset;
        }

        .TextInput.TextInput.TextInput {
            border: none;
            padding: ${theme.spacing.all(1)};

            input {
                ${getTypographyStyle("body3Strong")}
                ::placeholder {
                    ${getTypographyStyle("body3Strong")}
                }
            }
        }
        &.Lg {
            .TextInput.TextInput {
                input {
                    ${getTypographyStyle("body2Strong")}
                    ::placeholder {
                        ${getTypographyStyle("body2Strong")}
                    }
                }
            }
        }
    `,
);
